<template>
  <div id="cancelation-policy">
    <div class="tab-content py-0 px-0">
      <div>
        <v-row>
          <v-col class="text-right mr-5">
            <button class="btn btn-add-new" @click="addCancellation">{{ $t("ADD_NEW") }}</button>
          </v-col>
        </v-row>
        <v-data-table
          disable-sort
          :headers="headers"
          :items="dataTable"
          :items-per-page="15"
          hide-default-footer
          class="elevation-1 main-table"
        >
          <template slot="no-data">
            <span>{{$t("HAS_NO_DATA")}}</span>
          </template>
          <template v-slot:item.money="{ item }">
            <span>{{ _formatCurrency(item.money) }}</span>
          </template>
          <template v-slot:item.action="{ item }">
            <span class="edit" @click="editItem(item)">{{ $t("EDIT") }}</span>
            <span class="delete" @click="$refs.deleteDialogComponent.open(item)">{{ $t("DELETE") }}</span>
          </template>
        </v-data-table>
        <paging v-if="paging.total" :paging.sync="paging" @changePage="initialize">
          <span
            slot="totalItems"
            v-if="paging"
          >{{ $t("TOTAL") }}: {{ totalItems }} {{ $t("POLICY") }}</span>
        </paging>
      </div>
    </div>
    <delete-dialog @deleteItem="deleteItem" ref="deleteDialogComponent">
      <v-card-title slot="title" class="headline p-0">{{ $t("CONFIRM_DELETE_POLICY") }}?</v-card-title>
    </delete-dialog>
  </div>
</template>

<script>
import AddCancellation from "./AddCancellation.vue";
import Paging from "@/components/Utils/Paging.vue";
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import { service } from "@/_services/HotelSetting/cancellation-payment.service.js";
import { _formatCurrency, _formatDate, _alert } from "@/_helpers/function.js";

export default {
  components: {
    "add-cancellation": AddCancellation,
    paging: Paging,
    "delete-dialog": DeleteDialog
  },
  data() {
    return {
      isListingPage: true,
      dialog: false,
      headers: [
        {
          text: this.$t("EFFECTIVE_DATE"),
          align: "left",
          value: "timeApply"
        },
        {
          text: this.$t("CANCEL_ROOM_IN_ROUND_X_DAY_BEFORE_CHECKIN"),
          value: "cancellationDay"
        },
        { text: this.$t("PERCENT"), value: "percent" },
        { text: this.$t("FIXED_MONEY"), value: "money" },
        { text: this.$t("ACTION"), value: "action", sortable: false }
      ],
      data: [],
      dataTable: [],
      editedIndex: -1,
      editedItem: null,
      paging: {
        total: 0,
        limit: 15,
        offset: 0
      },
      totalItems: null
    };
  },

  async created() {
    this.initialize();
  },
  mounted() {
    document
      .querySelector(".v-tab.v-tab--active")
      .classList.remove("v-tab--active");
    document
      .querySelector(".v-tab[tabIndex='2']")
      .classList.add("v-tab--active");
  },
  watch: {
    totalItems(value) {
      this.paging.total = value;
    }
  },
  methods: {
    initialize(params) {
      if (!params) {
        params = {
          limit: 15,
          offset: 0
        };
      }
      service.get(params).then(res => {
        this.data = res.data;
        this.totalItems = res.total;
        this.data.forEach(x => {
          x.timeApply =
            x.type == 0
              ? this.$t("ALWAYS")
              : `${_formatDate(x.startDate)} - ${_formatDate(x.endDate)}`;
        });
        this.paging = {
          total: this.totalItems,
          limit: params.limit,
          offset: params.offset
        };
        this.dataTable = this.data.map(x => {
          return {
            amount: x.amount,
            cancellationType: x.cancellationType,
            type: x.type,
            hotelId: x.hotelId,
            id: x.id,
            cancellationDay: x.cancellationDay,
            percent: !x.cancellationType ? "" : `${x.amount}%`,
            money: x.cancellationType ? "" : `${x.amount}`,
            endDate: x.endDate,
            startDate: x.startDate,
            timeApply: x.timeApply
          };
        });
      });
    },
    addCancellation() {
      this.$router.push({ name: "editCancellationPolicy", params: { id: 0 } });
    },

    editItem(item) {
      this.$router.push({
        name: "editCancellationPolicy",
        params: { id: item.id }
      });
    },

    deleteItem(item) {
      const index = this.data.indexOf(item);
      service.remove(item.id).then(res => {
        if (res.responseCode == 0) {
          this.totalItems -= 1;
          let params = {
            limit: 15,
            offset: this.paging.offset
          };
          this.initialize(params);
        }
        _alert(res, this.$t(res.data), false);
        this.$refs.deleteDialogComponent.close();
      });
    },

    save(item) {
      if (this.editedIndex > -1) {
        Object.assign(this.data[this.editedIndex], item);
      } else {
        this.data.push(item);
        this.initialize();
      }
      this.isListingPage = true;
    },
    redirect() {
      this.isListingPage = !this.isListingPage;
    },
    _formatCurrency: _formatCurrency
  }
};
</script>
